
import { useTranslation } from 'react-i18next';

export default function QuemSomos() {
  const { t } = useTranslation();

  return (
    <section id="quem-somos" className="py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6 leading-tight">
              {t('quemSomos.titulo')}
            </h2>
            <div className="w-20 h-1 bg-black mb-8"></div>
            <p
              className="text-lg text-gray-700 mb-6 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: t('quemSomos.texto1') }}
            />
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('quemSomos.texto2')}
            </p>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/f2bd418b0bfbfafabfbde3d1f67690ab/d0250fb402caa920a5bd7c238b904e72.jpeg"
                alt="Equipa Olhar Criativo"
                className="w-full h-full object-cover object-center"
              />
            </div>
            {/* Escape the slash in the Tailwind opacity utility to avoid JSX parsing issues */}
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-black\\/5 rounded-lg -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
